import { Component } from 'react'
import config from '../../../config.json'
import { MOVIE } from '../../../constants/itemTypes'
import EditAllMoviesListCheck from './EditAllMoviesListCheck'
import checkFSKExist from '../../../functions/checkFSKExist'
import TmdbExternalLink from '../../general/TmdbExternalLink'

class EditAllMoviesListItem extends Component {
    constructor(props) {
        super(props)
    }

    getAttrData(key, data) {
        if(data && data.hasOwnProperty(key)) {
            return data[key]
        } else {
            return false
        }
    }

    getData(keys) {
        const { itemData } = this.props

        let data = this.getAttrData(keys[0], itemData)

        if(1 < keys.length) {
            for(let i = 1; i < keys.length; i++)  {
                data = this.getAttrData(keys[i], data)
            }
        }

        return data
    }

    getCheck(keys, check) {
        const data = this.getData(keys)

        if('notEmpty' === check) {
            return data
        } else if('lengthNotZero' === check) {
            return data && data.length > 0
        } else if('fskExist' === check) {
            return checkFSKExist(data)
        }  else {
            return false
        }
    }

    render() {
        const { itemData, checkList, evenOddClass, movieMappings, tmdbMovies, onNavigate } = this.props

        const mapping = movieMappings && movieMappings[itemData.id]
        const tmdbUuid = mapping && mapping.tmdb
        const isTmdbLinked = !!tmdbUuid
        const tmdbMovie = tmdbUuid && tmdbMovies && tmdbMovies[tmdbUuid]
        const tmdbNumericId = tmdbMovie && tmdbMovie.tmdb_id

        return (
            <li  className={"list-item " + evenOddClass}>
                <div
                    className='moviedata-form-wrapper'
                    style={{ cursor: 'pointer' }}
                    onClick={() => onNavigate(`${config.routes.movies.path}/${MOVIE}/${itemData.id}/edit-item`)}
                >
                    <div className='movie-check-wrapper container-item'>
                        <div className="icon button-edit button-edit-selection button "></div>
                        <div className='text-small-light'>{itemData.titleDisplay || itemData.title}</div>
                        <div className='checklist container-checks'>
                            <div className="tmdb-list-item-actions">
                                {!isTmdbLinked && <div className="check-indicator has-no-content" />}
                                {isTmdbLinked && tmdbNumericId ? (
                                    <span onClick={e => e.stopPropagation()}>
                                        <TmdbExternalLink tmdbId={tmdbNumericId} className="tmdb-external-link text-small-light" />
                                    </span>
                                ) : (
                                    <button
                                        className="tmdb-link-btn text-small-regular"
                                        onClick={e => {
                                            e.preventDefault()
                                            onNavigate(`/tmdb/${itemData.id}?from=editallmovies`)
                                        }}
                                    >
                                        TMDB verknüpfen
                                    </button>
                                )}
                            </div>
                            {checkList.slice(1).map(({keys, check}, index) => (
                                <EditAllMoviesListCheck
                                    key={index}
                                    check={this.getCheck(keys, check)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default EditAllMoviesListItem
